import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { withUser } from '../user/UserContext';
import {
  FooterCopyright,
  FooterGroup,
  FooterItem,
  FooterSocial,
} from './components';
import { doctrineAnalytics } from '../utils/analyticsUtils';
import { UserContextType } from '../user/user.types';
import { withFeatures, WithFeaturesPropsType } from '../features/withFeatures';
import { isHomepage } from '../utils/pageName';

type Props = UserContextType & WithFeaturesPropsType;

export const RawFooter: FC<Props> = ({ loggedIn, isFeatureEnabled }) => {
  const trackClick = (name: string) => () => doctrineAnalytics(name);
  const source = 'footer_static';

  return (
    <footer className="footer" id="footer">
      <div className="footer__container">
        <FooterGroup title="Produit">
          <FooterItem href="/" source={source}>
            <FormattedMessage id="footer/Footer.tsx/1" />
          </FooterItem>

          {isFeatureEnabled('footer/fr') && (
            <>
              <FooterItem href="/tarifs" source={source}>
                <FormattedMessage id="footer/Footer.tsx/2" />
              </FooterItem>
              <FooterItem href="/j/envoi" source={source}>
                <FormattedMessage id="footer/Footer.tsx/3" />
              </FooterItem>
              <FooterItem href="/annuaire/avocat/a/1" source={source}>
                <FormattedMessage id="footer/Footer.tsx/4" />
              </FooterItem>
              <FooterItem href="/annuaire/cabinet/a/1" source={source}>
                <FormattedMessage id="footer/Footer.tsx/5" />
              </FooterItem>
            </>
          )}
          <FooterItem href="/repertoire/decision" source={source}>
            <FormattedMessage id="footer/Footer.tsx/6" />
          </FooterItem>
        </FooterGroup>

        <FooterGroup title="Ressources">
          <FooterItem
            href="/aide"
            target="_blank"
            rel="noopener noreferrer"
            source={source}
          >
            <FormattedMessage id="footer/Footer.tsx/7" />
          </FooterItem>

          {isFeatureEnabled('footer/fr') && (
            <>
              <FooterItem href="/avis" source={source}>
                <FormattedMessage id="footer/Footer.tsx/8" />
              </FooterItem>

              <FooterItem
                data-test-id="clickable"
                onClick={trackClick('Footer BlogClicked')}
                href="/blog"
                target="_blank"
                rel="noopener noreferrer"
                source={source}
              >
                <FormattedMessage id="footer/Footer.tsx/9" />
              </FooterItem>
            </>
          )}

          {!loggedIn && isHomepage() && (
            <FooterItem
              href="https://jelejure.fr"
              target="_blank"
              rel="noreferrer noopener"
            >
              <FormattedMessage id="footer/Footer.tsx/20" />
            </FooterItem>
          )}

          <FooterItem href="/cgu" source={source}>
            <FormattedMessage id="footer/Footer.tsx/11" />
          </FooterItem>
          {loggedIn && (
            <FooterItem href="/cgv" source={source}>
              <FormattedMessage id="footer/Footer.tsx/12" />
            </FooterItem>
          )}
          <FooterItem href="/donnees_personnelles" source={source}>
            <FormattedMessage id="footer/Footer.tsx/13" />
          </FooterItem>
          <FooterItem href="/cookies" source={source}>
            <FormattedMessage id="footer/Footer.tsx/14" />
          </FooterItem>
        </FooterGroup>

        <FooterGroup title="Entreprise">
          <FooterItem href="/a-propos" source={source}>
            <FormattedMessage id="footer/Footer.tsx/15" />
          </FooterItem>

          {isFeatureEnabled('footer/fr') && (
            <FooterItem href="/recrutement" source={source}>
              <FormattedMessage id="footer/Footer.tsx/16" />
            </FooterItem>
          )}

          <FooterItem href="https://medium.com/doctrine">
            <FormattedMessage id="footer/Footer.tsx/19" />
          </FooterItem>

          <FooterItem
            data-test-id="clickable"
            onClick={trackClick('Footer PressClicked')}
            href="https://doctrine.pr.co"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FormattedMessage id="footer/Footer.tsx/10" />
          </FooterItem>

          {isFeatureEnabled('footer/fr') && (
            <FooterItem href="/pdf/code_de_bonne_conduite.pdf" source={source}>
              <FormattedMessage id="footer/Footer.tsx/18" />
            </FooterItem>
          )}

          <FooterItem href="/contact" source={source}>
            <FormattedMessage id="footer/Footer.tsx/17" />
          </FooterItem>
        </FooterGroup>

        <FooterSocial />
      </div>

      <FooterCopyright />
    </footer>
  );
};

// @ts-ignore
export const Footer = withUser(withFeatures('all')(RawFooter));
